import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import { PAGES } from "../seo/pages.config";
import NavBar from "../components/NavbarTwo";
import FooterFour from "../components/FooterFour";

const NotFound = () => {
  return (
    <>
      <SEO canonical="/404" {...PAGES["/404"]} />
      <NavBar />
      <div className="error-area pd-top-120 pd-bottom-120">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-7 col-lg-10">
              <div className="error-page-content text-center">
                <h1 className="display-1 mb-4" style={{ fontSize: 'clamp(5rem, 15vw, 10rem)', fontWeight: '800', color: '#50af9b' }}>
                  404
                </h1>
                <h2 className="mb-3">Page Not Found</h2>
                <p className="mb-4 pb-3" style={{ fontSize: '1.1rem', color: '#666' }}>
                  Sorry, the page you're looking for doesn't exist or has been moved.
                </p>
                <div className="d-flex gap-3 justify-content-center flex-wrap">
                  <Link 
                    to="/" 
                    className="btn btn-main btn-base border-radius-5"
                    style={{ backgroundColor: '#50af9b', padding: '12px 30px' }}
                  >
                    Back to Homepage
                  </Link>
                  <Link 
                    to="/contact" 
                    className="btn btn-border-base border-radius-5"
                    style={{ padding: '12px 30px' }}
                  >
                    Contact Us
                  </Link>
                </div>
                <div className="mt-5 pt-4">
                  <h5 className="mb-3">Quick Links:</h5>
                  <div className="d-flex gap-4 justify-content-center flex-wrap">
                    <Link to="/funding/jumpstart" style={{ color: '#50af9b' }}>Funding Jumpstart</Link>
                    <Link to="/about" style={{ color: '#50af9b' }}>Accelerator</Link>
                    <Link to="/careers" style={{ color: '#50af9b' }}>Careers</Link>
                    <Link to="/apply" style={{ color: '#50af9b' }}>Apply Now</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterFour />
    </>
  );
};

export default NotFound;
